








// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { getDefaultAloFamily, AloFamily } from '@/models/alo/AloFamily';
import { toStringDictionary } from '@/utils/groupBy';

@Component({
  name: 'EditBaseFamily',    
  components:{EditDrawer}, 
  props: {
    title:String,            
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    }
  } 
})
export default class EditBaseFamily extends Vue {
  
  private original:AloFamily = getDefaultAloFamily()
  private modified:AloFamily = getDefaultAloFamily()
  private showDrawer = false
  private saving = false
    
  edit(item:AloFamily) {
    this.$store.myActions.ADM_FAMILY_RESET_STATUS()
    this.showDrawer = true
    this.original = {...getDefaultAloFamily(),...item}    
    this.modified = cloneDeep(this.original)
    
    return this.modified
  }
  
  get configuration(){
    return this.$store.myGetters.configuration
  }

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get familyStatus() {
    return this.$store.myGetters.familyStatus        
  }

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      this.$store.myActions.ADM_FAMILY_SAVE_REQUEST(this.modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.familyStatus)          
        this.showDrawer = false
      }).finally(()=>{
        this.saving = false
      })    
    } 
  }

}
